import { Dialog, DialogContent, Divider } from "@material-ui/core";
import { CloseOutlined } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getImage } from "../../../store/user/user.selector";
import { getVIPCircleRequest } from "../../../store/user/vipcircle/vipcircle.actions";
import { getCurrentVIPCircle } from "../../../store/user/vipcircle/vipcircle.selector";
import ManageVIPCircle from "./ManageVIPCircle";

const SetVIPSubscription = (props) => {
    const dispatch = useDispatch();
    const [mode, setMode] = useState("");
    const [selectedVIP, setSelectedVIP] = useState({});

    const { vipCircles } = useSelector((state) => {
        return {
            vipCircles: getCurrentVIPCircle(state),
        };
    });

    useEffect(() => {
        dispatch(getVIPCircleRequest());
    }, []);

    useEffect(() => {
        setMode("");
    }, [vipCircles]);

    return (
        <div className="">
            <Dialog
                maxWidth="sm"
                fullWidth
                open={mode === "add"}
                onClose={() => setMode("")}
            >
                <DialogContent>
                    <h3 className="text-lg font-medium text-ebony-color my-2">
                        Add VIP Circle
                        <CloseOutlined
                            className="float-right"
                            onClick={() => setMode("")}
                        />
                    </h3>
                    <Divider />
                    <ManageVIPCircle
                        VIPCircle={{}}
                        mode={"add"}
                        onClose={() => setMode("")}
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                maxWidth="sm"
                fullWidth
                open={mode === "edit"}
                onClose={() => setMode("")}
            >
                <DialogContent>
                    <h3 className="text-lg font-medium text-ebony-color my-2">
                        Update VIP Circle
                        <CloseOutlined
                            className="float-right"
                            onClick={() => setMode("")}
                        />
                    </h3>
                    <Divider />
                    <ManageVIPCircle
                        VIPCircle={selectedVIP}
                        mode={"edit"}
                        onClose={() => setMode("")}
                    />
                </DialogContent>
            </Dialog>
            <div className="mb-5 flex items-start justify-between">
                <div className="">
                    <h3 className="text-lg font-medium text-ebony-color">
                        VIP circle
                    </h3>
                    <p className="text-sm font-medium text-black-60">
                        User can set monthly and yearly subscription fees for
                        their private lounge.
                    </p>
                </div>
                <button
                    onClick={() => setMode("add")}
                    className="py-2.5 px-5 rounded-lg border border-black-10 bg-white text-sm font-medium text-black-50 flex items-center capitalize"
                >
                    <span className="mr-2 inline-block">
                        <svg
                            width="14"
                            height="14"
                            className="stroke-current"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7 1V13M13 7L1 7"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                    <span>Add circle</span>
                </button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                {vipCircles.map((x) => {
                    return (
                        <div className="p-4 rounded-lg border border-black-10">
                            <div className="flex flex-col sm:flex-row  gap-5 mb-6">
                                <div className="flex-1 align-center justify-center rounded-lg bg-white text-center">
                                    <img
                                        src={getImage(x.avatar)}
                                        className="w-[150px] h-[150px]"
                                    />
                                </div>
                                <div className="flex-1">
                                    <h3 className="capitalize mb-3">
                                        {x.title}
                                    </h3>
                                    <div className="text-sm text-black-60 relative flex flex-col bg-white mb-2">
                                        {x.description}
                                    </div>
                                    <div className="flex items-center justify-between capitalize">
                                        <div className="flex flex-col text-center">
                                            <span className="text-base font-bold text-black-60">
                                                {
                                                    x.guests.filter(
                                                        (x) =>
                                                            x.status ===
                                                            "Invited"
                                                    ).length
                                                }
                                            </span>
                                            <span className="text-extraSmall font-medium text-black-50">
                                                invited
                                            </span>
                                        </div>
                                        <div className="flex flex-col text-center">
                                            <span className="text-base font-bold text-black-60">
                                                {
                                                    x.guests.filter(
                                                        (x) =>
                                                            x.status ===
                                                            "Requested"
                                                    ).length
                                                }
                                            </span>
                                            <span className="text-extraSmall font-medium text-black-50">
                                                pending
                                            </span>
                                        </div>
                                        <div className="flex flex-col text-center">
                                            <span className="text-base font-bold text-black-60">
                                                {
                                                    x.guests.filter(
                                                        (x) =>
                                                            x.status ===
                                                            "Subscribed"
                                                    ).length
                                                }
                                            </span>
                                            <span className="text-extraSmall font-medium text-black-50">
                                                subscribed
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" space-y-[17px]">
                                <div className="relative flex flex-col bg-white mb-2">
                                    <input
                                        type="text"
                                        className="py-[9px] px-[13px] text-sm rounded-md border border-black-10 outline-none peer"
                                        required
                                        disabled
                                        id="monthly-subscription"
                                    />
                                    <label
                                        htmlFor="monthly-subscription"
                                        className="text-extraSmall text-black-50 capitalize pl-3 absolute top-2/4 -translate-y-2/4 peer-focus:-translate-y-6 peer-valid:-translate-y-6 peer-valid:bg-white peer-valid:px-1 peer-valid:ml-2 peer-focus:px-1 peer-focus:ml-2 duration-200 ease-in-out peer-focus:bg-white"
                                    >
                                        {x.monthlySubscription}
                                    </label>
                                    <span className="absolute top-2/4 -translate-y-2/4 right-[13px] text-sm text-black-30 capitalize">
                                        / month
                                    </span>
                                </div>
                                <div className="relative flex flex-col bg-white mb-2">
                                    <input
                                        type="text"
                                        className="py-[9px] px-[13px] text-sm rounded-md border border-black-10 outline-none peer"
                                        required
                                        disabled
                                        id="yearly-subscription"
                                    />
                                    <label
                                        htmlFor="yearly-subscription"
                                        className="text-extraSmall text-black-50 capitalize pl-3 absolute top-2/4 -translate-y-2/4 peer-focus:-translate-y-6 peer-valid:-translate-y-6 peer-valid:bg-white peer-valid:px-1 peer-valid:ml-2 peer-focus:px-1 peer-focus:ml-2 duration-200 ease-in-out peer-focus:bg-white"
                                    >
                                        {x.annuallySubscription}
                                    </label>
                                    <span className="absolute top-2/4 -translate-y-2/4 right-[13px] text-sm text-black-30 capitalize">
                                        / Yearly
                                    </span>
                                </div>
                                <div className="relative flex flex-col bg-white mb-2">
                                    <textarea
                                        cols={3}
                                        type="text"
                                        className="py-[9px] min-h-[48px] px-[13px] text-sm rounded-md border border-black-10 outline-none peer"
                                        required
                                        disabled
                                        id="description"
                                    ></textarea>
                                    <label
                                        htmlFor="description"
                                        className="text-extraSmall text-black-50 capitalize pl-3 absolute top-[9px] peer-focus:-translate-y-4 peer-valid:-translate-y-4 peer-valid:bg-white peer-valid:px-1 peer-valid:ml-2 peer-focus:px-1 peer-focus:ml-2 duration-200 ease-in-out peer-focus:bg-white"
                                    >
                                        {x.description}
                                    </label>
                                </div>

                                <button
                                    onClick={() => {
                                        setSelectedVIP(x);
                                        setMode("edit");
                                    }}
                                    className="flex items-center py-[9px] px-[30px] rounded-lg bg-orange-color text-white font-bold text-sm capitalize mt-4"
                                >
                                    <span className="inline-block mr-2 ">
                                        <svg
                                            width="15"
                                            height="15"
                                            viewBox="0 0 15 15"
                                            className="stroke-current"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M6.75 2.75H3C2.17157 2.75 1.5 3.42158 1.5 4.25V12.5C1.5 13.3284 2.17157 14 3 14H11.25C12.0784 14 12.75 13.3284 12.75 12.5V8.75M11.6893 1.68934C12.2751 1.10355 13.2249 1.10355 13.8107 1.68934C14.3964 2.27513 14.3964 3.22487 13.8107 3.81066L7.37132 10.25H5.25L5.25 8.12868L11.6893 1.68934Z"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </span>
                                    <span>Edit</span>
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SetVIPSubscription;
